<template>
  <div class="snackbar-wrapper" :class="{'bottom': isBottomPosition}">
    <s-snackbar
      v-for="list in lists"
      :key="list.id"
      :snackbar-data="list"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { mapState } from 'vuex'

export default {
  name: 'SnackbarWrapper',
  components: {
    SSnackbar: defineAsyncComponent(() => import('@/components/atoms/snackbar/Snackbar.vue'))
  },
  computed: {
    ...mapState('snackbar', ['lists', 'isBottomPosition'])
  }
}
</script>

<style scoped>
.snackbar-wrapper {
  position: fixed;
  top: 71px;
  left: 50%;
  z-index: 1051; /* need to increase because some modal is 1050 */
  display: flex;
  flex-direction: column;
  max-width: fit-content;
  width: 90%;
  align-items: center;
  transform: translate(-50%);
}
.snackbar-wrapper.bottom {
  top: unset;
  bottom: 50px;
  width: 100%;
  max-width: 316px;
}
</style>
